var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignUpService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 135.463,
    viewBox: "0 0 250 135.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1133",
    "data-name": "Group 1133",
    transform: "translate(-194.404 -394.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1118",
    "data-name": "Group 1118",
    transform: "translate(370.634 459.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M489.569,553.837H439.236a2.52,2.52,0,0,1-2.5-2.835l8.458-67.083h50.042a2.519,2.519,0,0,1,2.457,3.073Z",
    transform: "translate(-436.716 -483.919)",
    fill: "#777",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M511.146,553.837H463.075a2.519,2.519,0,0,1-2.479-2.073l-12.221-67.845h51.085a2.519,2.519,0,0,1,2.479,2.073l11.687,64.879A2.519,2.519,0,0,1,511.146,553.837Z",
    transform: "translate(-439.895 -483.919)",
    fill: "#d6d6d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_530",
    "data-name": "Ellipse 530",
    cx: 1.642,
    cy: 2.031,
    rx: 1.642,
    ry: 2.031,
    transform: "translate(17.659 4.995) rotate(-19.469)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_531",
    "data-name": "Ellipse 531",
    cx: 1.642,
    cy: 2.031,
    rx: 1.642,
    ry: 2.031,
    transform: "translate(23.275 4.995) rotate(-19.469)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_532",
    "data-name": "Ellipse 532",
    cx: 1.642,
    cy: 2.031,
    rx: 1.642,
    ry: 2.031,
    transform: "translate(28.892 4.995) rotate(-19.469)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_533",
    "data-name": "Ellipse 533",
    cx: 1.642,
    cy: 2.031,
    rx: 1.642,
    ry: 2.031,
    transform: "translate(34.508 4.995) rotate(-19.469)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_534",
    "data-name": "Ellipse 534",
    cx: 1.642,
    cy: 2.031,
    rx: 1.642,
    ry: 2.031,
    transform: "translate(40.124 4.995) rotate(-19.469)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_535",
    "data-name": "Ellipse 535",
    cx: 1.642,
    cy: 2.031,
    rx: 1.642,
    ry: 2.031,
    transform: "translate(45.741 4.995) rotate(-19.469)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_536",
    "data-name": "Ellipse 536",
    cx: 1.642,
    cy: 2.031,
    rx: 1.642,
    ry: 2.031,
    transform: "translate(51.357 4.995) rotate(-19.469)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M465.826,512.585l-2.674-.006a1.02,1.02,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.675.006a1.021,1.021,0,0,1,1,.812l.8,3.828A1.022,1.022,0,0,1,465.826,512.585Z",
    transform: "translate(-443.43 -490.134)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M473.949,512.6l-2.675-.006a1.021,1.021,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.674.006a1.02,1.02,0,0,1,1,.812l.8,3.828A1.02,1.02,0,0,1,473.949,512.6Z",
    transform: "translate(-445.645 -490.139)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M482.072,512.621l-2.675-.006a1.021,1.021,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.229l2.675.006a1.021,1.021,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,482.072,512.621Z",
    transform: "translate(-447.86 -490.144)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M490.194,512.638l-2.674-.006a1.02,1.02,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.675.006a1.021,1.021,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,490.194,512.638Z",
    transform: "translate(-450.075 -490.149)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M498.317,512.656l-2.675-.006a1.022,1.022,0,0,1-1-.812l-.8-3.828a1.022,1.022,0,0,1,1-1.23l2.674.006a1.021,1.021,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,498.317,512.656Z",
    transform: "translate(-452.29 -490.154)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M506.44,512.674l-2.675-.006a1.022,1.022,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.675.006a1.022,1.022,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,506.44,512.674Z",
    transform: "translate(-454.505 -490.158)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M514.562,512.693l-2.674-.006a1.021,1.021,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.674.006a1.021,1.021,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,514.562,512.693Z",
    transform: "translate(-456.721 -490.163)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M468,522.676l-2.675-.006a1.022,1.022,0,0,1-1-.812l-.8-3.828a1.022,1.022,0,0,1,1-1.23l2.674.006a1.021,1.021,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,468,522.676Z",
    transform: "translate(-444.024 -492.886)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M476.127,522.695l-2.674-.006a1.022,1.022,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.675.006a1.022,1.022,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,476.127,522.695Z",
    transform: "translate(-446.239 -492.891)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M484.25,522.712l-2.674-.006a1.02,1.02,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.674.006a1.02,1.02,0,0,1,1,.812l.8,3.828A1.02,1.02,0,0,1,484.25,522.712Z",
    transform: "translate(-448.454 -492.896)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M492.373,522.73l-2.675-.006a1.021,1.021,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.674.006a1.02,1.02,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,492.373,522.73Z",
    transform: "translate(-450.669 -492.901)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M500.5,522.748l-2.674-.006a1.02,1.02,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.229l2.675.006a1.021,1.021,0,0,1,1,.812l.8,3.829A1.022,1.022,0,0,1,500.5,522.748Z",
    transform: "translate(-452.884 -492.906)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M508.618,522.766l-2.674-.006a1.022,1.022,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.674.006a1.021,1.021,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,508.618,522.766Z",
    transform: "translate(-455.099 -492.91)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M516.741,522.783l-2.675-.006a1.022,1.022,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.675.006a1.022,1.022,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,516.741,522.783Z",
    transform: "translate(-457.315 -492.915)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M470.183,532.767l-2.674-.006a1.02,1.02,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.675.006a1.022,1.022,0,0,1,1,.812l.8,3.829A1.022,1.022,0,0,1,470.183,532.767Z",
    transform: "translate(-444.618 -495.638)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M478.306,532.786l-2.674-.006a1.022,1.022,0,0,1-1-.813l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.674.006a1.021,1.021,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,478.306,532.786Z",
    transform: "translate(-446.833 -495.643)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M486.429,532.8l-2.675-.006a1.022,1.022,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.675.006a1.022,1.022,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,486.429,532.8Z",
    transform: "translate(-449.048 -495.648)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M494.551,532.822l-2.674-.006a1.021,1.021,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.675.006a1.021,1.021,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,494.551,532.822Z",
    transform: "translate(-451.263 -495.653)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M502.674,532.839,500,532.833a1.021,1.021,0,0,1-1-.812l-.8-3.828a1.02,1.02,0,0,1,1-1.23l2.674.006a1.02,1.02,0,0,1,1,.812l.8,3.828A1.02,1.02,0,0,1,502.674,532.839Z",
    transform: "translate(-453.479 -495.658)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M510.8,532.857l-2.675-.006a1.021,1.021,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.675.006a1.021,1.021,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,510.8,532.857Z",
    transform: "translate(-455.694 -495.663)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M518.919,532.875l-2.674-.006a1.02,1.02,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.675.007a1.021,1.021,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,518.919,532.875Z",
    transform: "translate(-457.909 -495.667)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M472.362,542.859l-2.675-.006a1.021,1.021,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.674.006a1.02,1.02,0,0,1,1,.812l.8,3.828A1.02,1.02,0,0,1,472.362,542.859Z",
    transform: "translate(-445.212 -498.39)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M480.485,542.877l-2.675-.006a1.021,1.021,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.229l2.675.006a1.021,1.021,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,480.485,542.877Z",
    transform: "translate(-447.427 -498.395)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M488.607,542.895l-2.674-.006a1.02,1.02,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.674.006a1.023,1.023,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,488.607,542.895Z",
    transform: "translate(-449.642 -498.4)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M474.688,552.951l-2.675-.006a1.022,1.022,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.675.006a1.022,1.022,0,0,1,1,.812l.8,3.829A1.021,1.021,0,0,1,474.688,552.951Z",
    transform: "translate(-445.846 -501.142)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M482.81,552.969l-2.674-.006a1.021,1.021,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.675.006a1.022,1.022,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,482.81,552.969Z",
    transform: "translate(-448.061 -501.147)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M490.933,552.986l-2.675-.006a1.022,1.022,0,0,1-1-.812l-.8-3.828a1.022,1.022,0,0,1,1-1.23l2.674.006a1.02,1.02,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,490.933,552.986Z",
    transform: "translate(-450.276 -501.152)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M496.73,542.913l-2.675-.006a1.022,1.022,0,0,1-1-.812l-.8-3.829a1.022,1.022,0,0,1,1-1.23l2.674.006a1.021,1.021,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,496.73,542.913Z",
    transform: "translate(-451.857 -498.405)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M504.852,542.93l-2.674-.006a1.022,1.022,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.675.006a1.022,1.022,0,0,1,1,.812l.8,3.828A1.022,1.022,0,0,1,504.852,542.93Z",
    transform: "translate(-454.073 -498.41)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M512.975,542.948l-2.674-.007a1.02,1.02,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.674.006a1.02,1.02,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,512.975,542.948Z",
    transform: "translate(-456.288 -498.415)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M521.1,542.966l-2.675-.006a1.021,1.021,0,0,1-1-.812l-.8-3.828a1.021,1.021,0,0,1,1-1.23l2.674.006a1.02,1.02,0,0,1,1,.812l.8,3.828A1.021,1.021,0,0,1,521.1,542.966Z",
    transform: "translate(-458.503 -498.419)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1129",
    "data-name": "Group 1129",
    transform: "translate(218.677 394.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1119",
    "data-name": "Group 1119",
    transform: "translate(53.39 113.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M335.313,568.526H301.189l8.631-18.964h31.748Z",
    transform: "translate(-301.189 -549.561)",
    fill: "#777"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1120",
    "data-name": "Group 1120",
    transform: "translate(65.569 130.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M366.329,578.424H317.935v-5.331h48.394a2.666,2.666,0,0,1,2.665,2.665h0A2.666,2.666,0,0,1,366.329,578.424Z",
    transform: "translate(-317.935 -573.093)",
    fill: "#969696"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M323.263,564.975H301.627L310.92,545.2l-5.334-1.876-8.917,20.084a8.089,8.089,0,0,0-.7,3.28h0a3.618,3.618,0,0,0,3.618,3.618h23.779a2.671,2.671,0,0,0,2.58-3.351A2.736,2.736,0,0,0,323.263,564.975Z",
    transform: "translate(-246.377 -434.843)",
    fill: "#6d6d6d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1123",
    "data-name": "Group 1123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1121",
    "data-name": "Group 1121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M384.9,399.46a5.382,5.382,0,0,0-5.465-5.3H233.244a5.382,5.382,0,0,0-5.465,5.3v92.5H384.9Z",
    transform: "translate(-227.779 -394.165)",
    fill: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1122",
    "data-name": "Group 1122",
    transform: "translate(0 97.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M233.244,546.01H379.432a5.382,5.382,0,0,0,5.465-5.3v-12.09H227.779v12.09A5.382,5.382,0,0,0,233.244,546.01Z",
    transform: "translate(-227.779 -528.625)",
    fill: "#afafaf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1126",
    "data-name": "Group 1126",
    transform: "translate(5.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1124",
    "data-name": "Group 1124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M395.163,399.46a5.427,5.427,0,0,0-5.55-5.3H241.131a5.428,5.428,0,0,0-5.551,5.3v92.5H395.163Z",
    transform: "translate(-235.58 -394.165)",
    fill: "#3f3f3f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1125",
    "data-name": "Group 1125",
    transform: "translate(0 97.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M241.131,546.01H389.613a5.427,5.427,0,0,0,5.55-5.3v-12.09H235.58v12.09A5.428,5.428,0,0,0,241.131,546.01Z",
    transform: "translate(-235.58 -528.625)",
    fill: "#969696"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1127",
    "data-name": "Group 1127",
    transform: "translate(11.767 7.366)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_687",
    "data-name": "Rectangle 687",
    width: 147.397,
    height: 82.696,
    rx: 1.67,
    fill: "#6f38d4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_537",
    "data-name": "Ellipse 537",
    cx: 3.2,
    cy: 3.2,
    r: 3.2,
    transform: "translate(82.096 102.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1128",
    "data-name": "Group 1128",
    transform: "translate(31.595 23.927)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_688",
    "data-name": "Rectangle 688",
    width: 10.578,
    height: 2.48,
    rx: 1.24,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_689",
    "data-name": "Rectangle 689",
    width: 7.112,
    height: 2.48,
    rx: 1.24,
    transform: "translate(12.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_690",
    "data-name": "Rectangle 690",
    width: 7.112,
    height: 2.48,
    rx: 1.24,
    transform: "translate(100.502)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_691",
    "data-name": "Rectangle 691",
    width: 24.29,
    height: 39.188,
    rx: 2.561,
    transform: "translate(0 10.925)",
    fill: "#d8b0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_692",
    "data-name": "Rectangle 692",
    width: 24.29,
    height: 39.188,
    rx: 2.561,
    transform: "translate(27.774 10.925)",
    fill: "#d8b0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_693",
    "data-name": "Rectangle 693",
    width: 24.29,
    height: 39.188,
    rx: 2.561,
    transform: "translate(55.549 10.925)",
    fill: "#d8b0ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_694",
    "data-name": "Rectangle 694",
    width: 24.29,
    height: 39.188,
    rx: 2.561,
    transform: "translate(83.323 10.925)",
    fill: "#d8b0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_695",
    "data-name": "Rectangle 695",
    d: "M0,0H24.29a0,0,0,0,1,0,0V13.927a1.613,1.613,0,0,1-1.613,1.613H1.613A1.613,1.613,0,0,1,0,13.927V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 34.573)",
    fill: "#e5e1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_696",
    "data-name": "Rectangle 696",
    d: "M0,0H24.29a0,0,0,0,1,0,0V13.927a1.613,1.613,0,0,1-1.613,1.613H1.613A1.613,1.613,0,0,1,0,13.927V0A0,0,0,0,1,0,0Z",
    transform: "translate(27.774 34.573)",
    fill: "#e5e1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_697",
    "data-name": "Rectangle 697",
    d: "M0,0H24.29a0,0,0,0,1,0,0V13.927a1.613,1.613,0,0,1-1.613,1.613H1.613A1.613,1.613,0,0,1,0,13.927V0A0,0,0,0,1,0,0Z",
    transform: "translate(55.549 34.573)",
    fill: "#e5e1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_698",
    "data-name": "Rectangle 698",
    d: "M0,0H24.29a0,0,0,0,1,0,0V13.927a1.613,1.613,0,0,1-1.613,1.613H1.613A1.613,1.613,0,0,1,0,13.927V0A0,0,0,0,1,0,0Z",
    transform: "translate(83.323 34.573)",
    fill: "#e5e1ff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M372.86,500.857c-.415-.72-.981-1.711-1.475-2.6a.7.7,0,0,1,.476-1.025c.313-.061.667-.132,1.007-.2a.682.682,0,0,0,.285-1.205l-6.371-4.994a.682.682,0,0,0-1.1.56l.268,8.012a.682.682,0,0,0,1.148.474l.735-.69a.7.7,0,0,1,1.1.19l1.45,2.828a1.155,1.155,0,0,0,1.583.484l.452-.249A1.154,1.154,0,0,0,372.86,500.857Z",
    transform: "translate(-46.709 -26.323)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1132",
    "data-name": "Group 1132",
    transform: "translate(194.404 453.117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1130",
    "data-name": "Group 1130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M233.482,517.96c6.722-7.626,5.556-17.718.945-18.535-4.735-.839-7.93-2.575-9.362-10.1-1.22-6.415-2.856-12.28-7.583-13.8a6.03,6.03,0,0,0-5.687,1c-3.076,2.537-4.307,7.982-4.652,14.039-.355,6.212-2.42,8.372-5.689,9.33a10.11,10.11,0,0,0-6.6,5.772c-1.505,3.672,1.046,9.381,3.57,12.287Z",
    transform: "translate(-194.404 -475.222)",
    fill: "#7ece29",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M230.14,513.35c-1.747.033-2.323,3-4.175,2.715-2.415-.376-2.009-8.805-3.666-13.9-1.273-3.912-5.222-3.965-6.2.6-1.105,5.162-.817,12.907-3.523,12.962-1.537.031-2.5-1.009-3.327-2.155-2.642-3.666-5.634-1.1-5.689,3.01a10.226,10.226,0,0,0,3.93,7.94h23.047C233.621,521.254,234.711,513.264,230.14,513.35Z",
    transform: "translate(-196.901 -481.784)",
    fillRule: "evenodd",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1131",
    "data-name": "Group 1131",
    transform: "translate(2.296 42.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M206.273,570.142h20.269a4.491,4.491,0,0,0,3.778-2.033c4.09-6.329,5.486-18.093,5.962-25.385H197.576c.1,7.215.917,18.822,4.861,25.294A4.483,4.483,0,0,0,206.273,570.142Z",
    transform: "translate(-197.565 -536.369)",
    fill: "#e2af54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M197.668,533.986s-.147,2.576-.1,6.355h38.706c.247-3.777.247-6.355.247-6.355Z",
    transform: "translate(-197.561 -533.986)",
    fill: "#bf9149"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_699",
    "data-name": "Rectangle 699",
    d: "M2.368,0H39.031A2.368,2.368,0,0,1,41.4,2.368V5.084a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.368A2.368,2.368,0,0,1,2.368,0Z",
    transform: "translate(0.95 42.193)",
    fill: "#e2af54"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpService);
export default __webpack_public_path__ + "static/media/sign-up-service.8ab77c8195568b6201e96325942dba13.svg";
export { ForwardRef as ReactComponent };